'use client';

import { useDispatch } from 'react-redux';
import { useRouter } from 'next/navigation';
import { getTrackNumber } from '@/store/parcelTracking';
import { useState } from 'react';
import { receivingTrackService } from '@/lib/services/receivingTrackService';

export function useTrackHandler(input: string) {
    const dispatch = useDispatch();
    const router = useRouter();
    const [error, setError] = useState<string | null>(null);

    const handleTrackClick = async () => {
        if (!input || input === 'tracking') {
            return;
        }

        setError(null);

        try {
            const data = await receivingTrackService(input);

            if (data && data.result) {
                dispatch(getTrackNumber(data.result));
                router.push(`/tracking/${input.trim()}`);
            } else {
                setError('Номер заказа не найден');
            }
        } catch (error) {
            console.error(error);
            setError('Номер заказа не найден');
        }
    };

    const clearError = () => setError(null);

    return { handleTrackClick, error, clearError };
}
